import { createFileRoute } from '@tanstack/react-router';
import { AddonAppPage } from '@/features/addon-apps';

export const Route = createFileRoute('/_app/apps/$appSlug')({
  component: AddonAppPage,
});
